import { ChangeEvent } from 'react';
import { DropdownProps } from 'react-day-picker';

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/common';

export const MonthsDropdown = (props: DropdownProps) => {
  const { options, value, onChange, 'aria-label': ariaLabel } = props;

  const onValueChange = (newValue: string) => {
    if (onChange) {
      const syntheticEvent = {
        target: {
          value: newValue,
        },
      } as ChangeEvent<HTMLSelectElement>;

      onChange(syntheticEvent);
    }
  };

  return (
    <Select className="order-1 !w-fit !h-8" value={value?.toString()} onValueChange={onValueChange}>
      <SelectTrigger
        className="border-none !py-0 !px-3 !shadow-none [&_svg]:right-2 [&_svg]:!text-primary-base text-primary-base dark:text-primary-base data-[state=open]:bg-primary-lightest !gap-1 font-semibold !h-8 hover:bg-primary-lightest dark:hover:bg-primary-darker dark:data-[state=open]:bg-primary-darker"
        aria-label={ariaLabel}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="h-[256px] z-[1000]">
        <SelectGroup>
          {options?.map((option) => (
            <SelectItem
              key={option.value}
              value={option.value.toString()}
              disabled={option.disabled}
            >
              {option.label}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};
